import React from "react";
import { useTranslation } from "react-i18next";

import { useAppSelector, useAppDispatch } from "store/index";
import { handleUpdateFields } from "store/segments/slice";

import InnerInput from "components/inputs/InnerInput/InnerInput";
import SwitchBtn from "components/buttons/SwitchBtn";

interface Props { fieldErrors?: Record<string, string>; clearFieldError: (field: string) => void; }

const SegmentRulesActivityTab: React.FC<Props> = ({ fieldErrors, clearFieldError }) => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();

  const itemPayload = useAppSelector(
    (store) => store.segments.payload?.sessionRules
  );
  const payloadFull = useAppSelector((store) => store.segments.payload);

  const handleData = (
    key: string,
    value: string | boolean | number | number[] | string[]
  ) => {
    clearFieldError(key);
    const existingList = payloadFull?.sessionRules || [];
    const updatedRule = {
      ...existingList,
      [key]: parseFloat(value as string),
    };
    //   @ts-ignore
    dispatch(handleUpdateFields({ sessionRules: updatedRule }));
  };

  return (
    <div className="rules-payments-wrapper">
      <div className="segment-rules-form-wrapper">
        <div className="segments-rules-form-box big">
          <div className="segments-rules-form-box-item">
            <SwitchBtn
              isActive={
                !!itemPayload?.sessionMinuteMin ||
                !!itemPayload?.sessionMinuteMax
              }
              handleClick={() => {
                const isDisabled =
                  (itemPayload?.sessionMinuteMin === 0 ||
                    itemPayload?.sessionMinuteMin === undefined) &&
                  (itemPayload?.sessionMinuteMax === 0 ||
                    itemPayload?.sessionMinuteMax === undefined);
                dispatch(
                  // @ts-ignore
                  handleUpdateFields({
                    sessionRules: {
                      ...itemPayload,
                      sessionMinuteMin: isDisabled ? 1 : 0,
                      sessionMinuteMax: isDisabled ? 1 : 0,
                    },
                  })
                );
              }}
            />
            <InnerInput
              hasError={Boolean(fieldErrors?.["sessionMinuteMin"])}
              value={itemPayload?.sessionMinuteMin?.toString() ?? ""}
              placeholder={t("Min")}
              label={t("Min")}
              type="number"
              id="segment-sessionMinuteMin"
              onChange={(e) => handleData("sessionMinuteMin", e)}
              disabled={itemPayload?.sessionMinuteMin === 0}
            />
            <span className="txt">{t("sessionMinute")}</span>
            <InnerInput
              hasError={Boolean(fieldErrors?.["sessionMinuteMax"])}
              value={itemPayload?.sessionMinuteMax?.toString() ?? ""}
              placeholder={t("Max")}
              label={t("Max")}
              type="number"
              id="segment-sessionMinuteMax"
              onChange={(e) => handleData("sessionMinuteMax", e)}
              disabled={itemPayload?.sessionMinuteMax === 0}
            />
          </div>
          <div className="segments-rules-form-box-item">
            <SwitchBtn
              isActive={
                !!itemPayload?.sessionCountMin || !!itemPayload?.sessionCountMax
              }
              handleClick={() => {
                const isDisabled =
                  (itemPayload?.sessionCountMin === 0 ||
                    itemPayload?.sessionCountMin === undefined) &&
                  (itemPayload?.sessionCountMax === 0 ||
                    itemPayload?.sessionCountMax === undefined);
                dispatch(
                  // @ts-ignore
                  handleUpdateFields({
                    sessionRules: {
                      ...itemPayload,
                      sessionCountMin: isDisabled ? 1 : 0,
                      sessionCountMax: isDisabled ? 1 : 0,
                    },
                  })
                );
              }}
            />
            <InnerInput
              hasError={Boolean(fieldErrors?.["sessionCountMin"])}
              value={itemPayload?.sessionCountMin?.toString() ?? ""}
              placeholder={t("Min")}
              label={t("Min")}
              type="number"
              id="segment-sessionCountMin"
              onChange={(e) => handleData("sessionCountMin", e)}
              disabled={itemPayload?.sessionCountMin === 0}
            />
            <span className="txt">{t("sessionCount")}</span>
            <InnerInput
              hasError={Boolean(fieldErrors?.["sessionCountMax"])}
              value={itemPayload?.sessionCountMax?.toString() ?? ""}
              placeholder={t("Max")}
              label={t("Max")}
              type="number"
              id="segment-sessionCountMax"
              onChange={(e) => handleData("sessionCountMax", e)}
              disabled={itemPayload?.sessionCountMax === 0}
            />
          </div>
          <div className="segments-rules-form-box-item">
            <SwitchBtn
              isActive={
                !!itemPayload?.hoursAfterRegistrationMin ||
                !!itemPayload?.hoursAfterRegistrationMax
              }
              handleClick={() => {
                const isDisabled =
                  (itemPayload?.hoursAfterRegistrationMin === 0 ||
                    itemPayload?.hoursAfterRegistrationMin === undefined) &&
                  (itemPayload?.hoursAfterRegistrationMax === 0 ||
                    itemPayload?.hoursAfterRegistrationMax === undefined);
                dispatch(
                  // @ts-ignore
                  handleUpdateFields({
                    sessionRules: {
                      ...itemPayload,
                      hoursAfterRegistrationMin: isDisabled ? 1 : 0,
                      hoursAfterRegistrationMax: isDisabled ? 1 : 0,
                    },
                  })
                );
              }}
            />
            <InnerInput
              hasError={Boolean(fieldErrors?.["hoursAfterRegistrationMin"])}
              value={itemPayload?.hoursAfterRegistrationMin?.toString() ?? ""}
              placeholder={t("Min")}
              label={t("Min")}
              type="number"
              id="segment-hoursAfterRegistrationMin"
              onChange={(e) => handleData("hoursAfterRegistrationMin", e)}
              disabled={itemPayload?.hoursAfterRegistrationMin === 0}
            />
            <span className="txt">{t("hoursAfterRegistration")}</span>
            <InnerInput
              hasError={Boolean(fieldErrors?.["hoursAfterRegistrationMax"])}
              value={itemPayload?.hoursAfterRegistrationMax?.toString() ?? ""}
              placeholder={t("Max")}
              label={t("Max")}
              type="number"
              id="segment-hoursAfterRegistrationMax"
              onChange={(e) => handleData("hoursAfterRegistrationMax", e)}
              disabled={itemPayload?.hoursAfterRegistrationMax === 0}
            />
          </div>
        </div>
        <div className="segments-rules-form-box">
          <div className="segments-rules-switcher">
            <SwitchBtn
              activeTxt={t("active")}
              isActive={itemPayload?.isActive === 1}
              handleClick={() =>
                handleData(
                  "isActive",
                  itemPayload?.isActive && itemPayload?.isActive === 1 ? 0 : 1
                )
              }
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default SegmentRulesActivityTab;
